export default __webpack_public_path__ + "static/media/icon_rating.793c8ab2.svg";